const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const {
    SPAIN_PLANS_UNIVERSE_ID,
    BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER,
    BROKER_INVESTMENT_PLANS_PRODUCT_URL_PARAMETER
} = require('constants/index');
const { Promise } = require('es6-promise');
const { APIGet } = require('utilities/APIRequestHelper');
// @actions
const BrokerCustomWalletInvestmentsActions = require('./brokerCustomWalletInvestments');
const brokerStocksByTypeActions = require('actions/brokerStocksByType');
const brokerMyInvestmentsActions = require('actions/brokerMyInvestments');

function requestMyInvestmentFundsIsinSuccess(response) {
    const actionType = actionTypes.CW_GET_INVESTMENTS_ISIN_PLANS_SUCCESS;
    return {
        type: actionType,
        payload: {
            data: response
        }
    };
}

function requestStocksByTypeSuccess(response, fundsList, plansList, futuresList, valuesList) {
    return {
        type: actionTypes.BROKER_GET_STOCKS_BY_TYPE_SUCCESS,
        payload: {
            data: response,
            fundsList,
            plansList,
            futuresList,
            valuesList
        }
    };
}

function summarizeInvestmentsByType(stocksSummarization, stocksActivesSummarization, walletSummarization, totalSummarized, featureToggling, flagBasedMBFeatures) {
    return {
        type: actionTypes.BROKER_SUMMARIZE_INVESTMENTS_BY_TYPE,
        payload: {
            stocksSummarization,
            stocksActivesSummarization,
            walletSummarization,
            totalSummarized,
            featureToggling,
            flagBasedMBFeatures
        }
    };
}

function requestStocksByTypeFailure(response) {
    return {
        type: actionTypes.BROKER_GET_STOCKS_BY_TYPE_FAILURE,
        payload: {
            data: response
        }
    };
}

function getFundsProduct(dispatch, getState, requestData, typeId) {
    const url = apiURLBuilder.getURL('brokerGetMorningStarScreener', { type: typeId });

    APIGet(dispatch, url, requestData).then(function(response) {

        let state = getState().brokerCustomWalletInvestments.toJS();

        response.rows.forEach(function(fund) {
            state.products.funds.stocks.forEach(function(stateF, key) {
                if (stateF.customInstitutionSecurityId == fund.CustomInstitutionSecurityId) {
                    state.products.funds.stocks[key].secID = fund.secID;
                }
            });
        });

        dispatch(requestMyInvestmentFundsIsinSuccess(state));
    });
}

function getPlansProduct(dispatch, getState, requestData, typeId) {
    const url = apiURLBuilder.getURL('brokerGetMorningStarScreener', { type: typeId });

    APIGet(dispatch, url, requestData).then(function(response) {
        let state = getState().brokerCustomWalletInvestments.toJS();

        response.rows.forEach(function(plan) {
            state.products.plans.stocks.forEach(function(stateF, key) {
                if (stateF.customInstitutionSecurityId == plan.CustomInstitutionSecurityId) {
                    state.products.plans.stocks[key].secID = plan.secID;
                }
            });
        });

        dispatch(requestMyInvestmentFundsIsinSuccess(state));
    });
}

function getOtherProductsIsinsAction(dispatch, getState) {
    const state = getState().brokerCustomWalletInvestments;
    const fundsTypeId = BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER;
    const plansTypeId = BROKER_INVESTMENT_PLANS_PRODUCT_URL_PARAMETER;
    const funds = state.getIn(['products', 'funds', 'stocks']).toJS() || [];
    const plans = state.getIn(['products', 'plans', 'stocks']).toJS() || [];
    let productFunds = '';
    let productPlans = '';

    funds.forEach(function(fund) {
        productFunds += fund.customInstitutionSecurityId + ':';
    });

    plans.forEach(function(plan) {
        productPlans += plan.customInstitutionSecurityId + ':';
    });

    let requestData = {
        query: {
            securityDataPoints: 'CustomInstitutionSecurityId|secID|Name',
            pageSize: plans.length,
            outputType: 'json',
            languageId: 'es-ES',
            universeIds: SPAIN_PLANS_UNIVERSE_ID,
            filters: `CustomInstitutionSecurityId:IN:${productPlans}`
        }
    };

    getPlansProduct(dispatch, getState, requestData, fundsTypeId);
    requestData.query.pageSize = funds.length;
    requestData.query.universeIds = 'FOEUR$$ALL_2118';
    requestData.query.typeId = fundsTypeId;
    requestData.query.filters = `CustomInstitutionSecurityId:IN:${productFunds}`;
    getFundsProduct(dispatch, getState, requestData, plansTypeId);
}

const getOtherProductsIsins = () => (dispatch, getState) =>
    getOtherProductsIsinsAction(dispatch, getState);

const fetchAllMyInvestments = () => (dispatch) => {
    dispatch(brokerStocksByTypeActions.getStocksByType(false))
}

function getStocksByTypeAction(dispatch, getState, idPortfolioAccount) {
    const fetchMyInvestments = dispatch(BrokerCustomWalletInvestmentsActions.fetchMyInvestments(idPortfolioAccount));

    if (fetchMyInvestments) {
        // brokerWallets is already fetched in the main entry point, we only care to fetch myInvestments
        fetchMyInvestments.then(
            () => {
                const immBrokerMyInvestments = getState().brokerCustomWalletInvestments;
                const immBrokerWallets = getState().brokerWallets;
                const totalSummarized = immBrokerMyInvestments.get('totalSummarizedValues');

                dispatch(
                    summarizeInvestmentsByType(
                        immBrokerMyInvestments.get('products').toJS(),
                        immBrokerMyInvestments.get('distribucionPorRenta').toJS(),
                        immBrokerWallets.get('walletSummarization').toJS(),
                        totalSummarized.toJS(),
                        getState().flagBasedFeatures,
                        getState().flagBasedMBFeatures
                    )
                );
                getOtherProductsIsinsAction(dispatch, getState);
            })
            .then(() => dispatch(brokerMyInvestmentsActions.outdateMyInvestments()))
            .then(() => {
                dispatch(fetchAllMyInvestments());
            }).catch((error) => {
                dispatch(requestStocksByTypeFailure(error))
            });
    }

    //Did we need immBrokerCustomWallet or..
    const immBrokerMyInvestments = getState().brokerCustomWalletInvestments;

    if (immBrokerMyInvestments.get('isFetching') || immBrokerMyInvestments.get('fetchSuccess')) {
        const fundsList = getState().brokerWallets.get('fundsList').toJS();
        const plansList = getState().brokerWallets.get('plansList').toJS();
        const futuresList = getState().brokerWallets.get('futuresList').toJS();
        const valuesList = getState().brokerWallets.get('walletList').toList().toJS();
        const totalProductsList = getState().brokerMyInvestments
            .get('totalOriginalProducts')
            .toJS();
        dispatch(
            requestStocksByTypeSuccess(
                totalProductsList,
                fundsList,
                plansList,
                futuresList,
                valuesList
            )
        );
        getOtherProductsIsinsAction(dispatch, getState);

        return Promise.resolve();
    }

    return Promise.resolve();
}

const getStocksByType = (idPortfolioAccount) => (dispatch, getState) => (
    getStocksByTypeAction(dispatch, getState, idPortfolioAccount)
);

module.exports = {
    getStocksByType,
    getOtherProductsIsins,
    summarizeInvestmentsByType,
};
